import FilterColorful from "../../../Components/Buttons/FilterColorful";
export default function Filters({ activeFilter, setActiveFilter }) {
  return (
    <div className="w-full flex gap-2.5 items-center justify-start pt-px pb-2.5 border-b border-b-zi-border-light dark:border-b-zi-border-dark overflow-y-visible overflow-x-auto">
      <span className="text-xs font-light text-zi-text-light dark:text-zi-text-dark">
        فیلتر:
      </span>
      <FilterColorful
        SVGName="tick"
        text="فعال"
        className="w-24"
        color={activeFilter[0] ? "blue" : "gray"}
        activeFilter={activeFilter}
        setActiveFilter={setActiveFilter}
        filterIndex={0}
      />
      <FilterColorful
        SVGName="stall"
        text="غیر فعال"
        className="w-24"
        color={activeFilter[1] ? "yellow" : "gray"}
        activeFilter={activeFilter}
        setActiveFilter={setActiveFilter}
        filterIndex={1}
      />
      <FilterColorful
        SVGName="star"
        text="تکمیل شده"
        className="w-24"
        color={activeFilter[2] ? "green" : "gray"}
        activeFilter={activeFilter}
        setActiveFilter={setActiveFilter}
        filterIndex={2}
      />
      <FilterColorful
        SVGName="failed"
        text="رد شده"
        className="w-24"
        color={activeFilter[3] ? "red" : "gray"}
        activeFilter={activeFilter}
        setActiveFilter={setActiveFilter}
        filterIndex={3}
      />
    </div>
  );
}
